import { render, staticRenderFns } from "./ItemSnoozeEdit.vue?vue&type=template&id=62039396&scoped=true"
import script from "./ItemSnoozeEdit.vue?vue&type=script&lang=js"
export * from "./ItemSnoozeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62039396",
  null
  
)

export default component.exports